import { completeAnonymousHolterUploadV2, initAnonymousHolterUploadV2 } from "./api";
import { splitFileIntoChunks } from "./chunks";
import { AnonymousUploadInitResponse, UploadAnonymousHolterFileV2Options } from "./types";
import { createAnonymousHolterUploader } from "./uploaders/createAnonymousHolterUploader";
import { SmallFileHolterUploader } from "./uploaders/SmallFileHolterUploader";

const DEFAULT_CHUNK_SIZE_BYTES = 8 * 1024 * 1024;
export const DEFAULT_SMALL_FILE_UPLOAD_THRESHOLD_BYTES = 25 * 1024 * 1024;

const isCdmRecording = ({ file, filename }: UploadAnonymousHolterFileV2Options) => {
  const resolvedFilename = filename || (file as File).name;
  return typeof resolvedFilename === "string" && resolvedFilename.toLowerCase().endsWith(".cdm");
};

export const uploadAnonymousSmallHolterFileV2 = async (options: UploadAnonymousHolterFileV2Options) => {
  const smallFileThresholdBytes = options.smallFileUploadThresholdBytes ?? DEFAULT_SMALL_FILE_UPLOAD_THRESHOLD_BYTES;

  if (options.file.size > smallFileThresholdBytes) {
    throw new Error("File is too large for small anonymous file upload");
  }

  const uploader = new SmallFileHolterUploader({ initData: {}, chunks: [], options });

  return await uploader.upload();
};

export { completeAnonymousHolterUploadV2 };

export const uploadAnonymousHolterFileV2 = async (options: UploadAnonymousHolterFileV2Options) => {
  const chunkSizeBytes = options.chunkSizeBytes || DEFAULT_CHUNK_SIZE_BYTES;
  const smallFileThresholdBytes = options.smallFileUploadThresholdBytes ?? DEFAULT_SMALL_FILE_UPLOAD_THRESHOLD_BYTES;

  if (options.file.size <= smallFileThresholdBytes && !isCdmRecording(options)) {
    return await uploadAnonymousSmallHolterFileV2(options);
  }

  const chunks = splitFileIntoChunks(options.file, chunkSizeBytes);
  const initResponse: { data?: AnonymousUploadInitResponse } | undefined = await initAnonymousHolterUploadV2(options);
  const initData = initResponse?.data;

  if (!initData) {
    throw new Error("Could not initialize anonymous Holter upload");
  }

  const uploader = createAnonymousHolterUploader({ initData, chunks, options });

  return await uploader.upload();
};
